module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ar":{"new_client":"تسجيل زبون جديد"},"he":{"new_client":"לקוח חדש"}}')
  delete Component.options._Ctor
}
